import { Alert } from '@cmsgov/ds-medicare-gov';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import translate from '../functions/translate';
import Div from './div';
import '../css/validation.alert.css';

type AlertHeading = {
    heading?: string
    headingWithLink?: never
} | {
    heading?: never
    headingWithLink?: string | JSX.Element | null
}

type ErrorAlertProps = {
    errorMessage?: JSX.Element | string | null
    alreadyUnlocked?: boolean
    validationMessages?: JSX.Element[]
    className?: string
    headingId?: string
} & AlertHeading;

const ErrorAlert = (props: ErrorAlertProps) => {
    const {
        errorMessage,
        validationMessages,
        alreadyUnlocked,
        heading,
        className,
        headingId,
        headingWithLink
    } = props;

    const [unlockAccountLink, setUnlockAccountLink] = useState<JSX.Element | null>(null);

    const accountIsLockedError = (errorMessage === translate('your_account_lock_protect_information'));
    useEffect(() => {
        setUnlockAccountLink(null);
        if (errorMessage) {
            // make sure scrolled into view when error message changes
            const [alertEl] = document.querySelectorAll('.ds-c-alert');
            if (alertEl) {
                alertEl.scrollIntoView();
            }

            // add "Unlock your account" link for permanent lockout errors.
            if (accountIsLockedError) {
                setUnlockAccountLink(<>{' '}
                    <Link
                        to="/unlock-account">
                        {translate('unlock_my_account')}.
                    </Link>
                </>);
            }
        }
    }, [errorMessage, accountIsLockedError]);

    const getValidationMessages = () =>
        validationMessages && validationMessages.map((message, index) =>
            <li key={`alert-${index}`}>{message}</li>);

    const getAlreadyUnlockedAlert = () => {
        return alreadyUnlocked && <>
            {' '}<Link to="/login">{translate('log_in_upper')}</Link>
            {' '}{translate('now_start_using_account')}
        </>
    }

    return <>
        <Div isRow>
            <Div cols={12} colsMD={8}>
                <Alert
                    className={className || "ds-u-margin-top--3"}
                    heading={heading}
                    hideIcon={Boolean(heading || headingWithLink)}
                    headingId={headingId}
                    role={'alert'}
                    variation={'error'}
                >
                    {headingWithLink &&
                        <h2 className="ds-c-alert__heading" id="validationAlertHeader">
                            {headingWithLink}
                        </h2>}
                    {errorMessage}
                    {unlockAccountLink}
                    {getAlreadyUnlockedAlert()}
                    {(validationMessages && validationMessages.length > 0) &&
                        <ul className="ds-c-list">
                            {getValidationMessages()}
                        </ul>
                    }
                </Alert>
            </Div>
        </Div>
    </>;
};

export default ErrorAlert;